import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ChevronRight, Close } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import { useSelector } from "react-redux";
import Tag from "@semcore/tag";
import axios from "axios";
import { POST_CANCELPLAN } from "../../../../services/constants";
import { useTranslation } from "react-i18next";

export default function CancelPlanPopUp({ cancelPlan, setCancelPlan }) {
  const [manageValue, setManageValue] = useState("updateplan");
  const [reason, setReason] = useState("");
  const {t} = useTranslation()

  const email = useSelector((state) => state.email);

  const handleClose = () => {
    setReason("");
    setCancelPlan(false);
  };

  const handlePlanSubmit = async () => {
    const manage_plan_link = `https://billing.stripe.com/p/login/14k7us0IvchS8so6oo?prefilled_email=${email}`;
    if (manageValue === "cancelplan") {
      try {
        await axios.post(POST_CANCELPLAN(), {
          email,
          reason: reason,
        });
      } catch (error) {
      } finally {
        handleClose();
        window.open(manage_plan_link, "_blank");
      }
    } else {
      window.open(manage_plan_link, "_blank");
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={cancelPlan}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#E9E9E9",
            width: {
              xs: "90%", // Small devices (xs)
              sm: "60%", // Small devices
              md: "40%", // Medium devices
            },
            maxWidth: "600px", // Set a max width for large screens
            margin: "auto",
            // minHeight: "250px",
          },
        }}
        maxWidth="md" // This controls the Dialog's overall width at medium sizes
        fullWidth
      >
        <DialogTitle className="py-2">{t("cancel_plan.title")}</DialogTitle>{" "}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#000000",
          }}
        >
          <Close />
        </IconButton>
        <DialogContent className="py-0">
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              value={manageValue}
              name="radio-buttons-group"
              onChange={(e) => setManageValue(e.target.value)}
            >
              <FormControlLabel
                value="updateplan"
                control={<Radio />}
                label={t("cancel_plan.update_plan")}
              />
              <FormControlLabel
                value="cancelplan"
                control={<Radio />}
                label={t("cancel_plan.cancel_plan")}
              />
            </RadioGroup>
          </FormControl>
          {manageValue === "cancelplan" ? (
            <>
              <Box className="d-flex flex-items-center justify-content-between content-text my-2">
                <DialogContentText>
                {t("cancel_plan.content_text")}
                </DialogContentText>
                <Tag size="l" color="violet-500">
                  {reason?.length} / 10000
                </Tag>
              </Box>
              <FormControl fullWidth>
                <TextField
                  id="outlined-multiline-flexible"
                  placeholder="Share your feedback here..."
                  multiline
                  maxRows={3}
                  onChange={(e) => {
                    const value = e.target.value.slice(0, 10000); // enforce max manually as backup
                    setReason(value);
                  }}
                  value={reason}
                  required
                  rows={1}
                  inputProps={{
                    maxLength: 10000, // HTML-level enforcement
                  }}
                  sx={{
                    minWidth: "200px",
                    "& textarea": {
                      minHeight: "120px !important",
                      height: "120px !important",
                    },
                    "& .MuiInputBase-root": {
                      padding: "12px 10px",
                    },
                    "& .MuiInputBase-input": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // No border on focus
                    },
                  }}
                />
              </FormControl>
            </>
          ) : null}
        </DialogContent>
        <DialogActions className="py-3">
          <Button
            endIcon={<ChevronRight />}
            className="popup-btn submit-btn"
            variant="contained"
            onClick={handlePlanSubmit}
            disabled={manageValue === "cancelplan" && reason?.length < 10}
          >
           {t("cancel_plan.continue")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
